import { render, staticRenderFns } from "./ManageBalance.vue?vue&type=template&id=35a58502&"
import script from "./ManageBalance.vue?vue&type=script&lang=js&"
export * from "./ManageBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports